<template>
  <el-dialog :title="title" :visible.sync="open" :before-close="close" :append-to-body="true" width="400px">
    <el-select v-model="eventSelected" placeholder="Select" style="width:100%;">
      <el-option v-for='event in events' :key='event.id' :label='event.alias' :value='event.id'></el-option>
    </el-select>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ 'Cancel' }}</el-button>
      <el-button type="primary" @click="save">{{ 'Save' }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import HTTP from '@rocketfid/api'

export default {
  props: {
    idBubble: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      open: true,
      eventSelected: null
    }
  },
  computed: {
    ...mapState('events', {
      events: 'items'
    }),
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    title () {
      return 'Trigger event'
    }
  },
  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },
  methods: {
    ...mapActions('events', ['addEvent', 'removeEvent', 'loadEvents']),

    init () {
      if (this.site) {
        this.loadEvents(this.site.sitekey)
      }
    },

    save () {
      if (this.idBubble) {
        HTTP.axios.put(process.env.API + '/bubble/event/' + this.eventSelected + '/', {bubbles: [{id: this.idBubble}]})
          .then(() => {
            this.close()
          })
      }
    },

    close () {
      this.$emit('close')
    }
  }
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/messages/message-form.vue